import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialModule } from './material.module';
import { HttpClientModule } from '@angular/common/http';
import { httpInterceptorProviders } from './interceptors';
import { ToastrModule } from 'ngx-toastr';

import { TokenGuard } from './guards/token.guard';
import { TokenComponent } from './components/token/token.component';
import { DatePipe } from '@angular/common';
import { SlugPageComponent } from './components/slugPage/slug-page.component';
import { LayoutModule } from './layout/layout/layout.module';
import { SettingsModule } from './components/settings/settings.module';
import { AdminSetariModule } from './platform/nomenclatoare/admin-setari/admin-setari.module';
import { CereriModule } from './components/cereri/cereri.module';
import { SettingsActivitiesModule } from './components/activitati/settings-activities/settings-activities.module';
import { CopiiModule } from './components/activitati/copii/copii.module';
import { ContracteProgramariModule } from './components/activitati/contracte-programari/contracte-programari.module';
import { ProgramModule } from './components/activitati/program/program.module';
import { InregistrareProgramareModule } from './components/activitati/inregistrare-programare/inregistrare-programare.module';
import { ScansModule } from './components/activitati/scans/scans.module';
import { ConfirmareDocumenteModule } from './components/confirmare-documente/confirmare-documente.module';
import { NotificariModule } from './components/notificari/notificari.module';
import { SettingsActivitiesDocsModule } from './components/activitati/settings-activities-docs/settings-activities-docs.module';
import { SettingsActivitiesProgModule } from './components/activitati/settings-activities-prog/settings-activities-prog.module';
import { BeneficiariModule } from './components/activitati/beneficiari/beneficiari.module';

@NgModule({
    declarations: [
        AppComponent, TokenComponent, SlugPageComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        MaterialModule,
        HttpClientModule,
        LayoutModule,
        SettingsModule,
        CereriModule,
        ConfirmareDocumenteModule,
        NotificariModule,
        CopiiModule,
        BeneficiariModule,
        ScansModule,
        ContracteProgramariModule,
        ProgramModule,
        InregistrareProgramareModule,
        SettingsActivitiesModule,
        SettingsActivitiesDocsModule,
        SettingsActivitiesProgModule,
        AdminSetariModule,
        ToastrModule.forRoot(),
    ],
    providers: [httpInterceptorProviders, TokenGuard, DatePipe],
    bootstrap: [AppComponent]
})
export class AppModule { }
